import {useMutation, useQueryClient} from "react-query";
import {apiCall} from "./BaseApi";
import {ShopifyOrderDto} from "./Models/SettlementSalesDto";
import {PROJECT_SETTLEMENT_RESULT_CACHE_KEY, PROJECT_SETTLEMENT_SALES_CACHE_KEY} from "./ProjectSettlementApi";

export const useImportShopifyOrder = () => {

    const queryClient = useQueryClient();

    return useMutation(async (shopifyOrder: ShopifyOrderDto): Promise<void> => {
        return await apiCall({
            url: `/shopifyOrders/import/${shopifyOrder.id}`,
            method: 'POST',
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_SALES_CACHE_KEY)
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_RESULT_CACHE_KEY)
        }
    })
}


export const useImportShopifyOrderByPeriod = () => {

    const queryClient = useQueryClient();

    return useMutation(async (queryParams: {projectId: number, from: string, to: string}): Promise<void> => {
        return await apiCall({
            url: `/shopifyOrders/importPeriod`,
            method: 'POST',
            queryParams: queryParams
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_SALES_CACHE_KEY)
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_RESULT_CACHE_KEY)
        }
    })
}

export const useImportUnknownShopifyOrders = () => {

    const queryClient = useQueryClient();

    return useMutation(async (): Promise<void> => {
        return await apiCall({
            url: `/shopifyOrders/importUnknown`,
            method: 'POST',
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_SALES_CACHE_KEY)
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_RESULT_CACHE_KEY)
        }
    })
}